import { Box, IconButton, Paper, SvgIcon, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from "@mui/material";
import { useAppDispatch } from "app/hooks";
import HolzfinderLotListCheckbox from "components/inputs/HolzfinderLotListCheckbox";
import { MediumText } from "components/typography";
import { setAgentId } from "features/agent/agentSlice";
import { Edit, Eye } from "icons";
import React, { useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import styles from "./LosListe.module.css";


interface Props {
  listLengthTotal: number;
  tableHeaderList: string[];
  sortableHeaders?: string[];
  headersBackEndName?: string[];
  rowData: any;
  switchActive: boolean;
  link?: string;
  tab?: number;
  switchStatus?: Function | null;
  setPage: Function;
  setRowsPerPage: Function;
  page: number;
  rowsPerPage: number;
  setAgent?: boolean;
  isLotList: boolean;
  setCheckedBoxes?: Function;
  checkedBoxes?: string[]
}

export default function HolzfinderList(props: Props) {
  const { listLengthTotal, tableHeaderList, rowData, switchActive, link, tab, switchStatus, setPage, setRowsPerPage, page, rowsPerPage, setAgent = false, isLotList, checkedBoxes, setCheckedBoxes } = props
  const dispatch = useAppDispatch();

  const tabInfo = [
    { name: "active", color: "#c0d904" },
    { name: "inactive", color: "#F4DFDC" },
    { name: "sold", color: "#CED3CB" },
    { name: "planned", color: "#ACD9E5" },
  ]
  const getSwitchColor = function getSwitchColor(status: string, eligible_for_status_change: boolean = true) {
    var color = undefined
    if (!eligible_for_status_change) {
      return tabInfo[2].color;
    }
    tabInfo.forEach(function (value) {
      if (status === value.name) {
        color = value.color
      }
    })

    return color || "transparent"
  }
  const handleCheckboxChange = (id: string) => {
    if (isLotList && checkedBoxes && setCheckedBoxes) {
      const isAlreadyChecked = checkedBoxes.includes(id)
      var checkedBoxesUpdateCopy = [...checkedBoxes];
      if (isAlreadyChecked) {
        const index = checkedBoxesUpdateCopy.indexOf(id)
        checkedBoxesUpdateCopy.splice(index, 1)
      } else {
        checkedBoxesUpdateCopy.push(id)
      }
      setCheckedBoxes(checkedBoxesUpdateCopy)
    }
  }
  const handleCheckboxChangeHeader = (event: any) => {
    if (isLotList && checkedBoxes && setCheckedBoxes) {
      var checkedBoxesUpdateRef = [...checkedBoxes]
      // Check if every row is checked
      const allChecked = rowData.every((row: any) => checkedBoxes?.includes(row.id));
      if (allChecked) {
        // Deselect all
        checkedBoxesUpdateRef = checkedBoxesUpdateRef.filter((id: string) => !rowData.some((row: any) => row.id === id));
      } else {
        // Select all
        rowData.forEach((row: any) => {
          if (!checkedBoxesUpdateRef.includes(row.id)) {
            checkedBoxesUpdateRef.push(row.id);
          }
        });
      }
      setCheckedBoxes(checkedBoxesUpdateRef)
    }
  }


  const resetCheckboxes = useCallback(() => {
    if (!setCheckedBoxes) return;
    setCheckedBoxes([]);
  }, [setCheckedBoxes]);

  useEffect(() => {
    resetCheckboxes();
  }, [tab, resetCheckboxes]);

  return (
    <div style={{ display: "flex", width: "100%"}}>
      {listLengthTotal > 0 ? (
        <Box sx={{ alignSelf: "start", maxHeight: "100%", flexGrow: 1, overflow: "hidden" }}>
          <Box
            sx={{
              overflowY: "auto",
              overflowX: "hidden",
              height: "100%",
              boxSizing: "content-box",
              width: "auto",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                border: "1px solid #D0C2A8",
                borderRadius: "0px !important",
                width: "auto",
              }}
            >
              <Table
                sx={{
                  minWidth: 650,
                  color: "#D0C2A8",
                  width: "100%",
                }}
                aria-label="simple table"
              >
                <TableHead sx={{ width: "auto" }}>
                  <TableRow>
                    {isLotList ? (
                      <TableCell>
                        <HolzfinderLotListCheckbox checked={rowData.every((row: any) => checkedBoxes?.includes(row.id))} handleCheckBoxChange={handleCheckboxChangeHeader} disabled={false} isHeaderCheckbox={true} />
                      </TableCell>
                    ) : null}
                    {tableHeaderList.map((e, key) => (
                      <TableCell key={key} className={styles.tableHeader}>
                        <TableSortLabel hideSortIcon={true}>
                          {e}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowData.map((row: any, key: any) => (
                    <TableRow key={key}>
                      {isLotList && checkedBoxes ? (
                        <TableCell key={key + row.id}>
                          <HolzfinderLotListCheckbox checked={checkedBoxes.includes(row.id)} handleCheckBoxChange={() => handleCheckboxChange(row.id)} disabled={false} isHeaderCheckbox={false} />
                        </TableCell>
                      ) : null}
                      {row.src ? (
                        <TableCell sx={{ height: 50, width: 50 }} key={key}>
                          <Box
                            key={key}
                            component="img"
                            src={row.src}
                            alt=""
                            sx={{
                              width: 50,
                              aspectRatio: "16/9",
                              objectFit: "cover",
                            }} />
                        </TableCell>
                      ) : null}
                      {Object.entries(row).filter((row) => {
                        return row[0] !== "src" && row[0] !== "status" && row[0] !== "checked" && row[0] !== "id" && row[0] !== "eligible_for_status_change";
                      }).map(([key, value]: [string, any]) => (
                        <TableCell key={key}>{value}</TableCell>
                      ))}
                      {switchActive ? (
                        <TableCell>
                          <Switch
                            sx={{
                              width: "50px",
                              "span .MuiSwitch-thumb": {
                                backgroundColor: getSwitchColor(row.status, row.eligible_for_status_change)
                              },
                              ".MuiSwitch-track": {
                                backgroundColor: getSwitchColor(row.status, row.eligible_for_status_change),
                                borderRadius: "20px",
                                opacity: tab === 4 ? "0.8" : "1 !important",
                                "&:after, &:before": {
                                  color: "black",
                                  fontSize: "11px",
                                  position: "absolute",
                                },
                                "&:before": {
                                  content: "'On'",
                                  pr: 1,
                                },
                                "&:after": {
                                  right: 2,
                                  content: "'Off'",
                                },
                              },
                            }}
                            disabled={row.status === "sold" || !row.eligible_for_status_change}
                            checked={row.checked}
                            onChange={(event) => {
                              if (switchStatus) {
                                switchStatus(row.id, event.target.checked);
                              }
                            }} />
                        </TableCell>
                      ) : null}
                      <TableCell onClick={() => {
                        if (setAgent) dispatch(setAgentId(row.id));
                      }}>
                        <Link to={link && link.length > 0 ? link + `${row.id}` : `${row.id}`}>
                          <IconButton>
                            <SvgIcon>
                              {link && (link.includes("meine_einkaeufe")) ? (
                                <Eye />
                              ) : (
                                <Edit />
                              )}

                            </SvgIcon>
                          </IconButton>
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

          </Box>
          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50]}
            labelRowsPerPage="Reihen pro Seite:"
            labelDisplayedRows={({ from, to, count }) => {
              return "" + from + "-" + to + " von " + count;
            }}
            component="div"
            count={listLengthTotal}
            page={page}
            onPageChange={(event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
              dispatch(setPage(newPage))
            }}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
              dispatch(setRowsPerPage(+event.target.value));
              dispatch(setPage(0));
            }}
          />
        </Box>
      ) : (
        <Box sx={{
          width: "fit-content",
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          boxShadow: "7px 5px 5px 0px rgba(0,0,0,0.6)",
          backgroundColor: "#D3D3D3",
          padding: 1,
          mt: 1
        }}>
          <MediumText>
            Es gibt keinen Treffer zu ihrer Suche.
          </MediumText>
        </Box>
      )}
    </div>
  )
}
